module.exports = __webpack_public_path__ + "img/undraw_design_sprint_x3eb.427e7184.svg";